import React from 'react';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import { PRICING_MODEL } from '../../../../../config';
import { useFormBidValidatedValue } from '../../Bid/useFormBidValidatedValue';
import { BidFormField } from './BidFormField';
import styles from './bidFormField.module.scss';

export const VCPMBidType = () => {
    const {
        value: bid = '',
        onChange,
        failedValidationData,
        scrollRef,
    } = useFormBidValidatedValue({
        pricingModel: PRICING_MODEL.VCPM,
    });

    return (
        <BidFormField
            label={<FormattedMessage id="campaign.editor.bid.type.title.VCPM" defaultMessage="v.CPM" />}
            description={
                <FormattedMessage
                    id="campaign.editor.bid.type.description.VCPM"
                    defaultMessage="Cost per 1000 viewable impressions"
                />
            }
            labelClass={styles['label']}
            descriptionClass={styles['description']}
            ref={scrollRef}
            bid={bid}
            onBidChange={onChange}
            failedValidationData={failedValidationData}
        />
    );
};
